module.exports = __webpack_public_path__ + "static/media/connect_pers.d24ffc5f.svg";